<button
  data-test="stock-button"
  mat-stroked-button
  class="stock-button"
  [attr.aria-label]="'shared.stockEntry.buttonLabel' | translate"
  [matTooltip]="'shared.stockEntry.tooltip' | translate"
  (click)="openCurrentStock()"
>
  <span class="stock-button__content">
    <img
      ngSrc="../../../../../assets/icons/stock.svg"
      alt=""
      aria-hidden="true"
      class="stock-button__icon"
      height="22"
      width="22"
    />
    <span class="stock-button__text">{{ 'shared.stockEntry.buttonLabel' | translate }}</span>
  </span>
</button>
